import { ROUTES, ROUTES_KEYS } from "./routes";
import SignInContainer from "../screens/auth/signIn/container";
import PublicLayout from "../navigation/layout/PublicLayout";
import SignUpContainer from "../screens/auth/signUp/container";
import HomeContainer from "../screens/home/container";
import PrivateLayout from "../navigation/layout/PrivateLayout";
import EventsListContainer from "../screens/events/list/container";
import EventDetailContainer from "../screens/events/detail/container";
import ProfileContainer from "../screens/profile/container";
import SearchContainer from "../screens/search/container";
import CompleteProfileContainer from "../screens/auth/completeProfile/container";
import JoinRoomContainer from "../screens/events/zoomPlayer/container";
import StandsListContainer from "../screens/stands/list/container";
import StandDetailContainer from "../screens/stands/detail/container";
import CategoriesListContainer from "../screens/categories/list/container";
import CategoryDetailContainer from "../screens/categories/detail/container";
import ForgotPasswordContainer from "../screens/auth/forgotPassword/container";
import ConfirmEmailContainer from "../screens/auth/confirmEmail/container";
import TermsOfServiceContainer from "../screens/terms-of-service/container";
import LinkedInPopupContainer from "../screens/auth/linkedInPopup/container";
import ComingSoonContainer from "../screens/coming-soon/container";
import { Page } from "../data/interfaces";
import ChatContainer from "../screens/chat/container";
import AuthActionContainer from "../screens/auth/action/container";
import PreRegisteredContainer from "../screens/auth/preRegistered/container";
import PrivacyPolicyContainer from "../screens/privacy-policy/container";
import CookiePolicyContainer from "../screens/cookie-policy/container";
import TutorialsContainer from "../screens/tutorials/container";
import FAQContainer from "../screens/faq/container";

export const PAGES: Page[] = [
  // Public pages
  {
    exact: false,
    path: ROUTES.SIGN_IN,
    key: ROUTES_KEYS.SIGN_IN,
    label: "Sign in",
    auth: false,
    component: SignInContainer,
    layout: PublicLayout,
  },
  {
    exact: false,
    path: ROUTES.SIGN_UP,
    key: ROUTES_KEYS.SIGN_UP,
    label: "Sign up",
    auth: false,
    component: SignUpContainer,
    layout: PublicLayout,
  },
  {
    exact: false,
    path: ROUTES.FORGOT_PASSWORD,
    key: ROUTES_KEYS.FORGOT_PASSWORD,
    label: "Forgot password",
    auth: false,
    component: ForgotPasswordContainer,
    layout: PublicLayout,
  },
  {
    exact: false,
    path: ROUTES.PRE_REGISTERED,
    key: ROUTES_KEYS.PRE_REGISTERED,
    label: "Pre registered",
    auth: false,
    component: PreRegisteredContainer,
    layout: PublicLayout,
  },
  {
    exact: false,
    path: ROUTES.LINKEDIN_SIGN_IN,
    key: ROUTES_KEYS.LINKEDIN_SIGN_IN,
    label: "Linkedin Sign in",
    auth: false,
    component: LinkedInPopupContainer,
    layout: PublicLayout,
  },
  {
    exact: false,
    path: ROUTES.CONFIRM_EMAIL,
    key: ROUTES_KEYS.CONFIRM_EMAIL,
    label: "Confirm email",
    auth: false,
    component: ConfirmEmailContainer,
    layout: PublicLayout,
  },
  {
    exact: false,
    path: ROUTES.AUTH_ACTION,
    key: ROUTES_KEYS.AUTH_ACTION,
    label: "Auth action",
    auth: false,
    component: AuthActionContainer,
    layout: PublicLayout,
  },
  {
    exact: false,
    path: ROUTES.TERMS_OF_SERVICE,
    key: ROUTES_KEYS.TERMS_OF_SERVICE,
    label: "Terms of service",
    auth: false,
    alwaysVisible: true,
    component: TermsOfServiceContainer,
    layout: PublicLayout,
  },
  {
    exact: false,
    path: ROUTES.PRIVACY_POLICY,
    key: ROUTES_KEYS.PRIVACY_POLICY,
    label: "Privacy Policy",
    auth: false,
    alwaysVisible: true,
    component: PrivacyPolicyContainer,
    layout: PublicLayout,
  },
  {
    exact: false,
    path: ROUTES.COOKIE_POLICY,
    key: ROUTES_KEYS.COOKIE_POLICY,
    label: "Cookie Policy",
    auth: false,
    alwaysVisible: true,
    component: CookiePolicyContainer,
    layout: PublicLayout,
  },
  {
    exact: false,
    path: ROUTES.TUTORIALS,
    key: ROUTES_KEYS.TUTORIALS,
    label: "Tutorials",
    auth: false,
    alwaysVisible: true,
    component: TutorialsContainer,
    layout: PublicLayout,
  },
  {
    exact: false,
    path: ROUTES.FAQ,
    key: ROUTES_KEYS.FAQ,
    label: "FAQ",
    auth: false,
    alwaysVisible: true,
    component: FAQContainer,
    layout: PublicLayout,
  },
  // Authenticated pages
  {
    exact: false,
    path: ROUTES.COMPLETE_PROFILE,
    key: ROUTES_KEYS.COMPLETE_PROFILE,
    label: "Complete profile",
    auth: true,
    component: CompleteProfileContainer,
    layout: PrivateLayout,
  },
  {
    exact: false,
    path: ROUTES.COMING_SOON,
    key: ROUTES_KEYS.COMING_SOON,
    label: "Coming Soon",
    auth: true,
    component: ComingSoonContainer,
    layout: PrivateLayout,
  },
  {
    exact: false,
    path: ROUTES.CHAT,
    key: ROUTES_KEYS.CHAT,
    label: "Chat",
    auth: true,
    component: ChatContainer,
    layout: PrivateLayout,
  },
  {
    exact: true,
    path: ROUTES.HOME,
    key: ROUTES_KEYS.HOME,
    label: "Home",
    auth: true,
    component: HomeContainer,
    layout: PrivateLayout,
  },
  {
    exact: false,
    path: ROUTES.STANDS,
    key: ROUTES_KEYS.STANDS,
    label: "Exhibition Rooms",
    auth: true,
    component: StandsListContainer,
    layout: PrivateLayout,
    nested: [
      {
        exact: false,
        path: ROUTES.STAND_DETAIL,
        key: ROUTES_KEYS.STAND_DETAIL,
        label: ":standName",
        auth: true,
        component: StandDetailContainer,
        layout: PrivateLayout,
      },
    ],
  },
  {
    exact: false,
    path: ROUTES.EVENTS,
    key: ROUTES_KEYS.EVENTS,
    label: "Conference Rooms",
    auth: true,
    component: EventsListContainer,
    layout: PrivateLayout,
    nested: [
      {
        exact: false,
        path: ROUTES.EVENT_DETAIL,
        key: ROUTES_KEYS.EVENT_DETAIL,
        label: ":eventName",
        auth: true,
        component: EventDetailContainer,
        layout: PrivateLayout,
      },
    ],
  },
  {
    exact: false,
    path: ROUTES.CATEGORIES,
    key: ROUTES_KEYS.CATEGORIES,
    label: "Categories",
    auth: true,
    component: CategoriesListContainer,
    layout: PrivateLayout,
    nested: [
      {
        exact: false,
        path: ROUTES.CATEGORY_DETAIL,
        key: ROUTES_KEYS.CATEGORY_DETAIL,
        label: "Category detail",
        auth: true,
        component: CategoryDetailContainer,
        layout: PrivateLayout,
      },
    ],
  },
  {
    exact: false,
    path: ROUTES.ZOOM_PLAYER,
    key: ROUTES_KEYS.ZOOM_PLAYER,
    label: "Zoom player",
    auth: true,
    component: JoinRoomContainer,
    layout: PrivateLayout,
  },
  {
    exact: false,
    path: ROUTES.SEARCH,
    key: ROUTES_KEYS.SEARCH,
    label: "Search",
    auth: true,
    component: SearchContainer,
    layout: PrivateLayout,
  },
  {
    exact: false,
    path: ROUTES.PROFILE,
    key: ROUTES_KEYS.PROFILE,
    label: "Profile",
    auth: true,
    component: ProfileContainer,
    layout: PrivateLayout,
  },
];
